import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { MultipleSelect } from 'shared/ui/MultipleSelect';
import { getUserName, useGetPaginatedUsersListingQuery } from 'entities/User';
import { ZonesEditKeys } from '../model/types';

interface UsersSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  onClear: (filterKey: string) => void;
}

export const UsersSelect: FC<UsersSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('contracts');

  const { data } = useGetPaginatedUsersListingQuery({ limit: 1000 });

  const selectOptions = useMemo<Array<{ label: string; value: string }>>(() => {
    if (!data?.content) {
      return [];
    }

    return data.content.map((user) => {
      return {
        label: getUserName(user),
        value: user.userId,
      };
    });
  }, [data]);

  const clearFilter = useCallback(() => {
    onClear(ZonesEditKeys.userIds);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string[]): void => {
      value.length ? onChange(value) : clearFilter();
    },
    [onChange, clearFilter],
  );

  return (
    <MultipleSelect
      containerClassName="flex-1"
      className="w-full"
      label={t('Assigned to')}
      placeholder={t('All')}
      bordered
      allowClear
      options={selectOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
      filterOption={(input: string, option) =>
        String(option?.label || '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  );
});
